import { Component, OnInit } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'eos-invalidity-show-wrapper',
  template: `
    <div class="form-group" [class.has-error]="showError">
      <label *ngIf="to.label && to.hideLabel !== true" [attr.for]="id">
        {{ to.label }}
        <span *ngIf="to.required && to.hideRequiredMarker !== true">*</span>
      </label>
      <div [ngbTooltip]="to.validityText" [disableTooltip]="!to.showUsingTooltip" tooltipClass="delegate-tooltip">
       <ng-template  #fieldComponent> </ng-template>
       </div>
       <span *ngIf="to.validityText && to.validityText.length>0 && !to.showUsingTooltip" style="color:#dc3545;font-size: 80%;">{{to.validityText}}</span>
       <div *ngIf="showError" class="invalid-feedback" [style.display]="'block'">
        <formly-validation-message [field]="field"></formly-validation-message>
      </div>
  </div>`,
})
export class InvalidityShowWrapperComponent extends FieldWrapper {
}
